import React from 'react'
import { com } from '@eidu/web'
import { Text } from '@common/ui'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import EntityFormReferenceDisplay from './EntityFormReferenceDisplay'
import EntityFormTextDisplay from './EntityFormTextDisplay'
import EntityFormDateDisplay from './EntityFormDateDisplay'
import EntityFormNumberDisplay from './EntityFormNumberDisplay'
import Field = com.eidu.entity.field.Field
import FieldType = com.eidu.entity.field.FieldType

export type EntityFormDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormDisplay = ({ field, fieldValue }: EntityFormDisplayProps) => {
  switch (field.type) {
    case FieldType.Text:
      return <EntityFormTextDisplay field={field} fieldValue={fieldValue} />
    case FieldType.Date:
      return <EntityFormDateDisplay field={field} fieldValue={fieldValue} />
    case FieldType.Number:
      return <EntityFormNumberDisplay field={field} fieldValue={fieldValue} />
    case FieldType.Reference:
      return <EntityFormReferenceDisplay field={field} fieldValue={fieldValue} />
    default:
      return (
        <Text key={`field-${field.id.toString()}`}>
          Field &quot;{field.name}&quot; has unsupported type {field.type.name}
        </Text>
      )
  }
}

export default EntityFormDisplay
